import AuthService from './authService.js';

class AttachmentService {
  static GetAttachmentByEntityTypeIdAndEntityId(entityTypeId, entityId) {
    return AuthService.getInstance().CallBackendFunction(
      '/api/Attachment/GetAttachmentList/?' + 'entityTypeId=' + entityTypeId + '&entityId=' + entityId
    );
  }

  static DownloadAttachmentFile(attachmentId) {
    const url = `/api/Attachment/GetAttachmentFile/${attachmentId}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static PostAttachmentFile(data) {
    const authService = AuthService.getInstance();

    const url = '/api/Attachment/PostUploadAttachmentFile/';

    return authService.CallBackendFunctionPostFile(url, data);
  }

  // Administrators only. A refusal (the file of a payment export) comes back as { error }, not as a failed call.
  static DeleteAttachment(attachmentId) {
    return AuthService.getInstance().CallBackendFunctionDelete(`/api/Attachment/DeleteAttachment/${attachmentId}`);
  }
}

export default AttachmentService;
